import { createFileRoute, useLocation } from '@tanstack/react-router'
import { z } from 'zod'
import { orderListSearchSchema, ServiceOrderCreateForm } from '@/features/order/index.ts'

export const Route = createFileRoute('/_authenticated/orders/service/new')({
  component: NewServiceOrderPage,
  head: () => ({ meta: [{ title: '新建服务订单 · Super Mega' }] }),
  loaderDeps: ({ search }) => ({ customerId: search.customerId }),
  loader: async ({ context, deps }) => {
    if (!deps.customerId) {
      return undefined
    }
    const customers = await context.queryClient.fetchQuery(
      context.trpc.lookup.customers.queryOptions({ purpose: 'order.service.read', selectedId: deps.customerId })
    )
    return customers.at(0)
  },
  validateSearch: z.object({
    customerId: z.coerce.number().int().positive().optional().catch(undefined)
  })
})

function NewServiceOrderPage() {
  const { currentSession } = Route.useRouteContext()
  const { customerId } = Route.useSearch()
  const savedReturnSearch = useLocation({ select: (location) => location.state.serviceOrderListReturnSearch })
  const returnSearch = orderListSearchSchema.parse(savedReturnSearch ?? {})
  return (
    <ServiceOrderCreateForm
      key={customerId}
      initialCustomer={Route.useLoaderData()}
      returnSearch={returnSearch}
      canCreateBusiness={currentSession.isSuperAdmin || currentSession.permissions.includes('business.create')}
      canCreateCustomer={currentSession.isSuperAdmin || currentSession.permissions.includes('customer.create')}
    />
  )
}
